import {
  ONE_DAY,
  ONE_HOUR,
  ONE_MINUTE,
  ONE_SECOND,
  ONE_WEEK,
  ONE_YEAR,
} from "core/constants";

interface Levels {
  [key: string]: number;
}

const levels = {
  years: ONE_YEAR,
  weeks: ONE_WEEK,
  days: ONE_DAY,
  hours: ONE_HOUR,
  minutes: ONE_MINUTE,
  seconds: ONE_SECOND,
} as Levels;

export const humanizeTime = (milliseconds: number) =>
  Object.keys(levels).reduce(
    (acc, level) => {
      const label = level;
      const denominator = levels[level];
      const [value, humanizedValue] = acc;
      const parsedValue = Number(value);
      const levelVal = Math.floor(parsedValue / denominator);
      if (!levelVal) return acc;
      return [
        parsedValue % denominator,
        `${humanizedValue} ${Number(levelVal).toLocaleString()} ${
          value === 1 ? label.substr(0, label.length - 1) : label
        }`.trim(),
      ];
    },
    [milliseconds, ""],
  )[1];
